import React, { Fragment } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Button from '../Buttons/Button';

const AddToListButton = ({
  onOpen, disabled, buttonText, size, variant = 'secondary', icon = 'hicon-plus', withoutIcon,
}) => (
  <Button
    className="add-to-list-button"
    disabled={disabled}
    size={size}
    variant={variant}
    shape={!buttonText ? 'square' : undefined}
    onClick={onOpen}
  >
    {buttonText
      ? <Fragment>{!withoutIcon && <i className={cx(icon)} />}{buttonText}</Fragment>
      : <i className={icon === 'hicon-plus' ? 'hicon-plus-thin' : icon} style={{ lineHeight: 1.5 }} />}
  </Button>
);

AddToListButton.propTypes = {
  onOpen: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  buttonText: PropTypes.string.isRequired,
  size: PropTypes.string,
  variant: PropTypes.string,
  icon: PropTypes.string,
  withoutIcon: PropTypes.bool,
};

export default AddToListButton;
